export default "__VITE_ASSET__9de630dc__"